var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BillingCardPreference',[(_vm.billingData && Object.keys(_vm.billingData).length > 0)?_c('BillingContactFilled',{attrs:{"data":_vm.billingData,"editable":_vm.editable}}):_c('BillingContactEmpty')],1)}
var staticRenderFns = []

export { render, staticRenderFns }